import { render, staticRenderFns } from "./edit-lead.vue?vue&type=template&id=495ccf51"
import script from "./edit-lead.vue?vue&type=script&lang=js"
export * from "./edit-lead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports